import React from "react";
export var RangeSlider = function (_a) {
    var min = _a.min, max = _a.max, value = _a.value, step = _a.step, onChange = _a.onChange, onMouseUp = _a.onMouseUp;
    var handleChange = function (event) {
        onChange(Number(event.target.value));
    };
    var handleMouseUp = function (event) {
        if (onMouseUp) {
            onMouseUp(Number(event.currentTarget.value));
        }
    };
    return (React.createElement("input", { type: "range", min: min, max: max, value: value, step: step, onChange: handleChange, onMouseUp: handleMouseUp, className: "scl-a-range-slider" }));
};
